<div class="box-table">

	<span class="title-accordion" [class.active]="!isCollapsed" (click)="isCollapsed = !isCollapsed"
		(keypress)="isCollapsed = !isCollapsed">
		{{ labels().MA_AP_RECAP_COMPONENT_TITLE }}
		<div class="fake-material-icon icon-expand expand"></div>
	</span>

	<table class="table" [ngbCollapse]="isCollapsed">
		<thead>
			<tr>
				<th></th>
				<th>{{ labels().MA_AP_RECAP_COMPONENT_VALUE_HEADER }} <br />
					({{ (isLeft ? sideEnum.Left : sideEnum.Right) | anatomicalSideLabel }})
				</th>
				<th>{{ labels().MA_AP_RECAP_COMPONENT_TARGET_HEADER }}</th>
			</tr>
		</thead>
		<tbody>
			@if (isMAD) {
			<tr [class.row-selected]="!isValidMAD">
				<td>{{ labels().MA_AP_RECAP_COMPONENT_MAD }} <br /> {{ rangeMAD }}</td>
				<td>{{ rpmMeasures?.rpm_ap_MAD }}</td>
				<td></td>
			</tr>
			}
			@if (isMNSA) {
			<tr [class.row-selected]="!isValidMNSA">
				<td>{{ labels().MA_AP_RECAP_COMPONENT_MNSA }} <br /> {{ rangeMNSA }}</td>
				<td>{{ rpmMeasures?.rpm_ap_MNSA }}</td>
				<td></td>
			</tr>
			}
			@if (isLPFA) {
			<tr [class.row-selected]="!isValidLPFA">
				<td>{{ labels().MA_AP_RECAP_COMPONENT_LPFA }} <br /> {{ rangeLPFA }}</td>
				<td>{{ rpmMeasures?.rpm_ap_LPFA }}</td>
				<td>{{ def_standardAngles_LPFA }}</td>
			</tr>
			}
			@if (isMPFA) {
			<tr [class.row-selected]="!isValidMPFA">
				<td>{{ labels().MA_AP_RECAP_COMPONENT_MPFA }} <br /> {{ rangeMPFA }}</td>
				<td>{{ rpmMeasures?.rpm_ap_MPFA }}</td>
				<td></td>
			</tr>
			}
			@if (isMLDFA) {
			<tr [class.row-selected]="!isValidMLDFA">
				<td>{{ labels().MA_AP_RECAP_COMPONENT_MLDFA }} <br /> {{ rangeMLDFA }}</td>
				<td>{{ rpmMeasures?.rpm_ap_mLDFA }}</td>
				<td>{{ def_standardAngles_mLDFA }}</td>
			</tr>
			}
			@if (isJLCA) {
			<tr [class.row-selected]="!isValidJLCA">
				<td>{{ labels().MA_AP_RECAP_COMPONENT_KNEE_JLCA }} <br /> {{ rangeJLCA }}</td>
				<td>{{ rpmMeasures?.rpm_ap_JLCA }}</td>
				<td></td>
			</tr>
			}
			@if (isKneeTransl) {
			<tr [class.row-selected]="!isValidKneeTransl">
				<td>{{ labels().MA_AP_RECAP_COMPONENT_KNEE_TRANSL }} <br /> {{ rangeKneeTransl }}</td>
				<td>{{ rpmMeasures?.rpm_ap_kneeTranslation }}</td>
				<td></td>
			</tr>
			}
			@if (isMPTA) {
			<tr [class.row-selected]="!isValidMPTA">
				<td>{{ labels().MA_AP_RECAP_COMPONENT_MPTA }} <br /> {{ rangeMPTA }}</td>
				<td>{{ rpmMeasures?.rpm_ap_MPTA }}</td>
				<td>{{ def_standardAngles_MPTA }}</td>
			</tr>
			}
			@if (isLDTA) {
			<tr [class.row-selected]="!isValidLDTA">
				<td>{{ labels().MA_AP_RECAP_COMPONENT_LDTA }} <br /> {{ rangeLDTA }}</td>
				<td>{{ rpmMeasures?.rpm_ap_LDTA }}</td>
				<td>{{ def_standardAngles_LDTA }}</td>
			</tr>
			}
		</tbody>
	</table>

</div>